import { initialState } from '../../initialState';

import scheduleReducer from './scheduleReducer';
import loadingReducer from './loadingReducer';
import racecardReducer from './racecardReducer';

import {
    RACING_LOADING,
    RACING_LOADING_SUCCESS,
    RACING_LOADED_EMPTY,
    RACING_UPDATE_SCHEDULE,
    RACING_UPDATE_SCHEDULE_FROM_CACHE,
    RACING_INVALIDATE_SCHEDULE_CACHE,
    RACING_LOADING_ERROR,
    RACING_WS_EVENT_UPDATE,
    RACING_RACECARD_UPDATE,
    RACING_RACECARD_UPDATE_FROM_CACHE,
    RACING_INIT,
    RACING_RACECARD_UPDATE_SELECTION_PRICE,
    RACING_WS_EVENT_UNSUBSCRIBE,
    RACING_SET_IS_STREAMING,
} from '../actions/types';

/**
 * Main racing widget reducer
 * @param {Object} state the current state
 * @param {Object} action the action
 * @returns {Object} new state
 */
export default function racingReducer(state = initialState, action) {
    switch (action.type) {
        case RACING_LOADING:
        case RACING_LOADING_SUCCESS:
        case RACING_LOADED_EMPTY:
        case RACING_LOADING_ERROR: {
            return loadingReducer(state, action);
        }
        case RACING_INIT:
        case RACING_UPDATE_SCHEDULE:
        case RACING_UPDATE_SCHEDULE_FROM_CACHE:
        case RACING_INVALIDATE_SCHEDULE_CACHE:
        case RACING_WS_EVENT_UPDATE:
        case RACING_WS_EVENT_UNSUBSCRIBE: {
            return scheduleReducer(state, action);
        }
        case RACING_RACECARD_UPDATE:
        case RACING_RACECARD_UPDATE_SELECTION_PRICE:
        case RACING_RACECARD_UPDATE_FROM_CACHE: {
            return racecardReducer(state, action);
        }
        case RACING_SET_IS_STREAMING: {
            return {
                ...state,
                isStreaming: action.data,
            };
        }
        default:
            return state;
    }
}
